import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import { Avatar, Divider, ListItemIcon, Menu, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Logout from '@mui/icons-material/Logout';
import { useNavigate } from "react-router-dom";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useEffect, useState } from "react";
import VendorProfile from '../Components/VendorProfile/VendorProfile';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from "@mui/material/ListSubheader";
import ListItemText from "@mui/material/ListItemText";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";
import Logo from "../Logo_No_Bg.png";
import { readCachedStoreInfo, refreshStoreInfo, STORE_INFO_EVENT } from "../utils/storeInfo";
import { logoutCleanup } from "../store/logoutCleanup";
const NAV_ITEMS = [
	{ title: "Home", route: "/home", icon: HomeRoundedIcon },
	{ title: "Departments", route: "/md", icon: CategoryOutlinedIcon },
	{ title: "Manage Products", route: "/mp", icon: InventoryRoundedIcon },
	{ title: "Manage Orders", route: "/orders", icon: ShoppingCartOutlinedIcon },
	{ title: "Manage Payment Accounts", route: "/payments", icon: CreditCardIcon },
	{ title: "Manage Transactions", route: "/transactions", icon: ReceiptLongIcon },
];

export default function Header() {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const [profileOpen, setProfileOpen] = useState(false);

	const [navOpen, setNavOpen] = useState(false);
	const location = useLocation();

	const toggleNav = (force) => () =>
		setNavOpen((prev) => (typeof force === "boolean" ? force : !prev));


	const go = (route) => {
		setNavOpen(false);
		navigate(route);
	};


	const [storeName, setStoreName] = useState(() => readCachedStoreInfo().name);
	const [storeLocation, setStoreLocation] = useState(() => readCachedStoreInfo().location);
	const displayName = storeName || "My Store";

	const navigate = useNavigate();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 600);
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		const handler = (e) => {
			const { businessName, businessLocation } = e.detail || {};
			if (businessName) setStoreName(businessName);
			if (businessLocation) setStoreLocation(businessLocation);
		};
		window.addEventListener(STORE_INFO_EVENT, handler);
		return () => window.removeEventListener(STORE_INFO_EVENT, handler);
	}, []);

	useEffect(() => {
		refreshStoreInfo();
	}, []);

	return (
		<Box sx={{ zIndex: 1300 }}>
			<ThemeProvider theme={theme}>
				<AppBar position="static" sx={{ backgroundColor: theme.palette.primary.main, }}>
					<Toolbar>
						<IconButton
							size="large"
							edge="start"
							color="black"
							aria-label="open drawer"
							sx={{ mr: 1, p: 0.5, fontWeight: 'bold' }}
							onClick={toggleNav()}
						>
							<MenuIcon />
						</IconButton>
						<img style={{ width: 50, height: 50 }} src={Logo} alt="Logo" />
						<Box sx={{
							display: 'flex',
							flexDirection: isMobile ? 'column' : 'row',
							textAlign: 'left',
							userSelect: 'none',
							gap: isMobile ? 0 : 2
						}}>
							<Typography variant="h5" sx={{ color: '#000', textShadow: "0 0 #000", marginTop: 0.5 }}>
								{displayName}
							</Typography>
							{storeLocation && <Typography
								variant="caption"
								sx={{
									fontSize: '0.85rem',
									color: 'rgba(0,0,0,0.8)',
									display: 'flex',
									alignItems: 'center',
									textShadow: "0 0 #fff", fontWeight: 'bold',
									ml: isMobile ? "-4px" : "0px",
									...(isMobile && {
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										display: '-webkit-box',
										WebkitLineClamp: 1,
										WebkitBoxOrient: 'vertical',
										wordBreak: 'break-word',
									})
								}}
							>
								<LocationOnIcon sx={{ fontSize: 22, color: '#FF9500' }} />
								{storeLocation}
							</Typography>}
						</Box>

						<Box sx={{ flexGrow: 1 }} />
						<Box sx={{ display: 'flex' }}>
							<Tooltip title="Account">
								<IconButton
									onClick={handleClick}
									size="small"
									sx={{ ml: 1.5 }}
									aria-controls={open ? 'account-menu' : undefined}
									aria-haspopup="true"
									aria-expanded={open ? 'true' : undefined}
								>
									<Avatar sx={{ width: 32, height: 32, backgroundColor: '#ff9500' }}>
										{(displayName[0] || "M").toUpperCase()}
									</Avatar>
								</IconButton>
							</Tooltip>
						</Box>
					</Toolbar>
				</AppBar>
				<Menu
					anchorEl={anchorEl}
					id="account-menu"
					open={open}
					onClose={handleClose}
					onClick={handleClose}
					slotProps={{
						paper: {
							elevation: 0,
							sx: {
								overflow: 'visible',
								filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
								mt: 1.5, borderRadius: 3, backgroundColor: 'rgb(255,241,223)',
								'& .MuiAvatar-root': {
									width: 32,
									height: 32,
									ml: -0.5,
									mr: 1,
								},
								'&::before': {
									content: '""',
									display: 'block',
									position: 'absolute',
									top: 0,
									right: 14,
									width: 10,
									height: 10,
									backgroundColor: 'background.paper',
									transform: 'translateY(-50%) rotate(45deg)',
									zIndex: 0,
								},
							},
						},
					}}
					transformOrigin={{ horizontal: 'right', vertical: 'top' }}
					anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
				>
					<MenuItem
						sx={{ display: 'flex', textAlign: 'center', fontWeight: 550, color: '#555' }}
						onClick={() => {
							handleClose();          // close the pop-menu
							setProfileOpen(true);   // open the profile dialog
						}}
					>
						<ListItemIcon>
							<AccountCircle sx={{ color: 'grey', ml: -0.5 }} />
						</ListItemIcon>My account
					</MenuItem>
					<Divider />
					<MenuItem sx={{ display: 'flex', textAlign: 'center', fontWeight: 550, color: '#555' }} onClick={() => {
						setAnchorEl(null);
						logoutCleanup();
						navigate('/', { replace: true });
					}}>
						<ListItemIcon>
							<Logout />
						</ListItemIcon>Logout
					</MenuItem>
				</Menu>
				<SwipeableDrawer
					anchor="left"
					open={navOpen}
					onOpen={toggleNav(true)}
					onClose={toggleNav(false)}
					ModalProps={{ disableScrollLock: true, keepMounted: true }}
					sx={{ zIndex: 1400, }}
					PaperProps={{
						sx: {
							width: { xs: '86vw', sm: 320 },   // responsive width
							maxWidth: '92vw',
							borderTopRightRadius: 14,
							borderBottomRightRadius: 14,
							overflow: 'hidden',
							bgcolor: 'background.paper',
						}
					}}
				>
					{/* Drawer Header */}
					<Box
						sx={{
							p: '12px',
							background: "linear-gradient(135deg, rgb(255, 167, 51) 0%, rgb(178, 101, 0) 100%)",
							color: "#fff",
						}}
					>
						<Box display="flex" alignItems="center" justifyContent="space-between">
							<Box>
								<Typography variant="h6" fontWeight={800} lineHeight={1.2}>
									{displayName}
								</Typography>
							</Box>

							<IconButton
								aria-label="close"
								onClick={toggleNav(false)}
								sx={{
									color: "#fff",
									bgcolor: "rgba(255,255,255,0.18)",
									"&:hover": { bgcolor: "rgba(255,255,255,0.28)" },
								}}
							>
								<CloseRoundedIcon />
							</IconButton>
						</Box>
					</Box>

					{/* Navigation List */}
					<List
						sx={{ py: 1.5 }}
						subheader={
							<ListSubheader component="div" sx={{ bgcolor: "transparent" }}>
								Menu
							</ListSubheader>
						}
					>
						{NAV_ITEMS.map(({ title, route, icon: Icon }) => {
							const active = location.pathname === route;
							return (
								<ListItemButton
									key={route}
									onClick={() => go(route)}
									selected={active}
									sx={{
										mx: 1.5,
										mb: 0.5,
										borderRadius: 2,
										"&.Mui-selected": {
											bgcolor: (t) => t.palette.action.selected,
										},
										"&:hover": {
											bgcolor: (t) => t.palette.action.hover,
										},
									}}
								>
									<ListItemIcon sx={{ minWidth: 36 }}>
										<Icon
											sx={{
												fontSize: 22,
												color: active ? theme.palette.primary.dark : theme.palette.secondary.main,
											}}
										/>
									</ListItemIcon>
									<ListItemText
										primary={title}
										primaryTypographyProps={{
											fontWeight: active ? 700 : 500,
										}}
									/>
								</ListItemButton>
							);
						})}
					</List>

					{/* Optional footer */}
					<Box sx={{ mt: "auto", p: 2, pt: 0.5 }}>
						<Typography variant="caption" color="text.secondary">
							Great to have you as a vendor in our Application
						</Typography>
					</Box>
				</SwipeableDrawer>
				<VendorProfile
					open={profileOpen}
					onClose={() => setProfileOpen(false)}
				/>
			</ThemeProvider>
		</Box>
	);
}
